import { UserNotification } from "../../@types/Users";
import { api } from "../api";

/**
 *  Max allowed 50
 */
export async function findMany(qnt: number): Promise<UserNotification[]> {
  try {
    const { data } = await api.get("/user-notifications", {
      params: {
        qnt,
      },
    });

    return data as UserNotification[];
  } catch (err) {
    console.log(err);
    return [];
  }
}
